// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Manrope', 'Manrope Fallback'","fontStyle":"normal"},"className":"__className_73ee6c","variable":"__variable_73ee6c"};